import React from 'react';
import PropTypes from 'prop-types';
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white";

import ButtonDeprecated from 'core/gd-components/buttons/gd-button/gd-button';
import UserSettingsFtue from "../../../client-data/user/ftue";

export default class ModalSkipTour extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            config: PropTypes.object,
            callback: PropTypes.func,
        })
    };

    state = {
        selected: false
    }

    onClick = () => {
        this.setState({
            selected: !this.state.selected
        })
    }

    onSubmit = () => {
        UserSettingsFtue.disableTourWarning();
        if (this.props.params.callback) this.props.params.callback();
    }

    render() {
        const checkboxClasses = Classes('ui5-cb', 's-13', 'm-r-10', this.props.className, {
            'selected': this.state.selected
        });

        return (
            <div className="v4-container placement-middle" onClick={(e)=>{e.stopPropagation()}}>
                <ModalV4HeaderWhite height={60} title=""/>

                <div className="content">
                    <div className="m-b-30">
                        <div className="image"/>
                    </div>

                    <div className="message m-b-20">You can access the Tour later from the <b>"More"</b> menu.</div>

                </div>

                <div className="actions">
                    <ButtonDeprecated className="submit"
                                      type="normal"
                                      label="Ok"
                                      onClick={this.onSubmit} />
                </div>
            </div>
        );
    }
}